'use client';
import { useRouter } from 'next/compat/router';
import { useSearchParams } from 'next/navigation';
import React, { type FC, useEffect, useMemo } from 'react';

import { useAuth } from '../../context/AuthContext';
import { COACH_SITE_URL, isServer } from '../../utils/constants';
import { BASE_SEARCH_PATH } from '../../utils/search';
import { LelandLocalStorage, RETURN_TO_KEY } from '../../utils/storage';
import { LoginFormV2 } from '../forms/LoginFormV2';

const LoginPage: FC = () => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const { currentUser, isLoadingUser } = useAuth();

  const localReturnTo = useMemo(() => {
    const url = LelandLocalStorage.getItem<string>(RETURN_TO_KEY);
    LelandLocalStorage.removeItem(RETURN_TO_KEY);

    return url;
  }, []);

  const redirectUrl = isServer
    ? ''
    : ((searchParams.get('redirect_url') as Optional<string>) ??
      localReturnTo ??
      BASE_SEARCH_PATH);

  useEffect(() => {
    if (isLoadingUser) {
      return;
    }

    // Redirect if already logged in
    if (currentUser?.applicant != null) {
      void router?.push(redirectUrl);
    } else if (currentUser?.coach != null) {
      window.location.href = COACH_SITE_URL;
    }
  }, [
    currentUser?.applicant,
    currentUser?.coach,
    isLoadingUser,
    redirectUrl,
    router,
  ]);

  return <LoginFormV2 className="w-full text-center" returnTo={redirectUrl} />;
};

export default LoginPage;
